<template>
    <el-dialog width="980px"  title="产品编辑" :before-close="handleClickCancel" class="ordinary_dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="standardEditVisible" append-to-body>
        <div class="details" v-loading="loading">
            <el-form size="small" ref="productForm"   v-loading="loading" label-position="left"  label-width="82px" :model="productForm"  :rules="productFormRules">
                <el-form-item label="产品名称：" class="label-bold" prop="goods_name">
                    <div v-text="productForm.goods_name || productForm.product_name"></div>
                </el-form-item>
                <el-form-item label="产品描述：" prop="description">
                    <el-input  v-model="productForm.description"  placeholder="请输入产品描述"></el-input>
                </el-form-item>

                <el-table class="custom_table" :data="productForm.skus" border row-key="product_name">
                    <el-table-column label="规格明细" prop="product_name" width="120">
                        <template slot-scope="{row}">
                            <div style="font-size: 14px;color: rgba(102, 102, 102, 1);line-height: 22px" >
                                <p v-for="item in row.specs">{{item.spec}}:{{item.spec_value}}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品别名" prop="goods_name" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input v-model="row.goods_name" placeholder="请输入产品别名"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="成本价" align="right" prop="cost_price" width="95" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input class="text_align_right" v-model="row.cost_price" placeholder="请输入" @blur="handleBlurPrice(row,'cost_price')"  size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否可销售" prop="is_sale" width="95" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-switch  v-model="row.is_sale" :active-value="1" :inactive-value="0"  active-color="#2990FF"></el-switch><span class="ml_5 switch_text" v-text="row.is_sale == 1 ?'是' : '否'"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售指导价" align="right" prop="sale_price" width="95" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input class="text_align_right" v-model="row.sale_price" placeholder="请输入" @blur="handleBlurPrice(row,'sale_price')"  size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否可租借" prop="is_lease" width="95" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-switch  v-model="row.is_lease" :active-value="1" :inactive-value="0"  active-color="#2990FF"></el-switch><span class="ml_5 switch_text" v-text="row.is_lease == 1 ?'是' : '否'"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="租借指导价" align="right" prop="lease_price" width="95" class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <el-input class="text_align_right" v-model="row.lease_price" placeholder="请输入" @blur="handleBlurPrice(row,'lease_price')"  size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" prop="handle" width="60">
                        <template slot-scope="{row,$index}">
                              <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDel(row,$index)">
                                  <i class="iconfont icon-shanchu1"></i>
                              </span>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="product_handle"  @click="handleClickAddSkus">
                    <span ><i class="el-icon-plus"></i>添加规格</span>
                </div>
            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
        <skusAdd :skusAddVisible.sync="skusAddVisible" v-if="skusAddVisible" :productId="productForm.id" :goodsId="goodsId" :skusSelectedData="productForm.skus"  @success="skusAddSuccess" />
    </el-dialog>
</template>
<script>
import { GoodsBasicProductDetail ,GoodsBasicProductEdit} from '@/api'
import skusAdd from './skus_add'
export default {
    name: 'standard_edit', //标准产品
    components: {
        skusAdd,
    },
    props: {
        standardEditVisible: {
            type: Boolean,
            default: false,
        },
        goodsId: {
            type: Number,
            default: 0,
        },
        goodsType: {
            type: String,
            default: '',
        },
        goodsInfo: {
            type: Object,
            default: ()=>{},
        },

    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            productForm:{
                product_name:'',
                description:'',
                image:[],
                skus:[],
            },
            productFormRules:{
                // category_name:[{ required: true, message: '请填写名称', trigger: 'blue'}],
            },
            skusAddVisible:false,

        }
    },
    created() {
        if(this.goodsId){
            this.getGoodsDetail()
        }
        if(this.goodsInfo){
            this.productForm = JSON.parse(JSON.stringify(this.goodsInfo))
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getGoodsDetail(){
            let postData = {
                goods_id : this.goodsId
            }
            this.loading = true
            GoodsBasicProductDetail(postData).then(res => {
                if (res.code === 200) {
                    let { product_id,product_name,goods_name,  description, unit,image, skus} = res.data
                    this.productForm = {
                        id:product_id,
                        goods_name,
                        description,
                        unit,
                        image,
                        skus
                    }
                }
                this.loading = false
            })
        },
        handleBlurPrice(row,field){
            let price = row[field].replace(',', '')
            price = row[field].replace(/[^\d.]/g, '')
            if(price < 0){
                row[field] = 0
            }
            price = Number(price).toFixed(2)
            row[field] =  Number(price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
        // 删除
        handleClickDel(row,index){
            if(this.productForm.skus.length == 1) return this.$message.error('至少选择一个产品')
            this.productForm.skus.splice(index,1)
        },
        // 添加规格
        handleClickAddSkus(){
            this.skusAddVisible = true
        },
        // 添加完规格后的回调
        skusAddSuccess(data){
            if(data){
                data.forEach((list)=>{
                    this.$set(list, 'goods_name', list.name)
                    this.$set(list, 'product_name', list.name)
                })
                this.productForm.skus = this.productForm.skus.concat(data)
            }
        },
        handleClickConfirm(){
            this.$refs.productForm.validate(valid => {
                if (valid) {
                    let flag = false
                    this.productForm.skus.forEach((childMap)=>{
                        if(!childMap.goods_name){
                            this.$message.error('产品别名不能为空')
                            flag = true
                        }
                    })
                    if(flag)return false
                    // this.BtnDisabled = true
                    if(this.goodsId){
                        let postData = {
                            goods_id : this.goodsId,
                            goods_name:this.productForm.goods_name,
                            image:this.productForm.image,
                            unit:this.productForm.unit,
                            description:this.productForm.description,
                            skus:this.productForm.skus.map((childMap)=>{
                                return {
                                    goods_sku_id:childMap.goods_sku_id,
                                    goods_name:childMap.goods_name,
                                    product_name:childMap.product_name,
                                    goods_id:childMap.goods_id,
                                    sku_id:childMap.sku_id,
                                    sku_key:childMap.sku_key,
                                    cost_price:childMap.cost_price ? childMap.cost_price.replace(/,+/g, '') : 0,
                                    is_sale:childMap.is_sale,
                                    is_lease:childMap.is_lease,
                                    sale_price : childMap.sale_price ? childMap.sale_price.replace(/,+/g, '') : 0,
                                    lease_price :childMap.lease_price ? childMap.lease_price.replace(/,+/g, '') : 0,
                                }
                            }),
                            is_online:this.productForm.skus.filter(find => (find.is_sale == 1 || find.is_lease == 1)).length  ? 1 :0
                        }
                        this.BtnDisabled = true
                        GoodsBasicProductEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => {
                                        this.BtnDisabled = false
                                        this.$emit('success')
                                        this.handleClickCancel()
                                    }
                                })
                            }else{
                                this.BtnDisabled = false
                            }
                        })

                    }else{
                        this.$emit('success',this.productForm)
                        this.handleClickCancel()
                    }
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:standardEditVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>

.label-bold {
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    ::v-deep .el-form-item__label{
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
    }
}
.ml_5{
    margin-left: 5px;
}
.switch_text{
    color: rgba(102, 102, 102, 1);
}
.text_align_right{
    ::v-deep .el-input__inner{
        text-align: right;
    }

}
.product_handle{
    width: 100%;
    border-radius: 4px;
    background: rgb(255, 255, 255);
    border: 1px dashed rgb(41, 144, 255);
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: rgb(41, 144, 255);
    cursor: pointer;
    i{
        margin-right: 4px;
    }
}
</style>
